import React, { useMemo } from 'react';
import s from './message-list.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loader } from '@shared/ui/loader/loader';
import { IconRefresh } from '@tabler/icons-react';
import { useMessageList } from '../model/use-message-list';
import { groupMessagesByDate } from '@entities/messanger';
import { MessageGroup } from './message-group';
import { MessageListSkeleton } from './message-skeleton';

export const MessageList = ({ profile, onRead }) => {
  const { messageHistory, isEnd, historyLoading, historyError, fetchMoreData, retryHistory } =
    useMessageList();
  const groups = useMemo(() => groupMessagesByDate(messageHistory), [messageHistory]);

  const showSkeleton = historyLoading && messageHistory.length === 0 && !historyError;
  const showEmpty = !historyLoading && !historyError && messageHistory.length === 0;
  const showError = historyError && messageHistory.length === 0;

  if (showSkeleton) {
    return (
      <div className={s.messagesContent} id="scrollableDiv">
        <MessageListSkeleton />
      </div>
    );
  }

  return (
    <div className={s.messagesContent} id="scrollableDiv">
      <InfiniteScroll
        dataLength={messageHistory?.length || 0}
        next={fetchMoreData}
        style={{ display: 'flex', flexDirection: 'column-reverse' }}
        inverse={true}
        loader={!historyError && <Loader size={18} />}
        className={s.messages}
        hasMore={!isEnd && !historyError}
        scrollThreshold={0.3}
        scrollableTarget="scrollableDiv"
      >
        {showEmpty && (
          <div className={s.emptyState}>
            <span>Напишите первое сообщение</span>
          </div>
        )}

        {showError && (
          <div className={s.errorState}>
            <p>{historyError}</p>
            <button className={s.retryBtn} onClick={retryHistory}>
              <IconRefresh size={16} /> Повторить
            </button>
          </div>
        )}

        {groups.map((group) => (
          <MessageGroup
            key={group.date}
            date={group.date}
            messages={group.messages}
            profile={profile}
            onRead={onRead}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};
